import React from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";

import { useSelector } from "react-redux";

import { Skeleton } from "@mui/material";

import { getShowConsumable } from "../../connections/getShowConsumable";
import dayjs from "dayjs";
import { putEnableDisableConsumable } from "../../connections/putEnableDisableConsumable";
import { toast } from "react-toastify";
import { formatDateTime } from "../../utils/constant/constant";
// import { Table } from "antd";

const ShowConsumable = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    data: getConsumableDetails,
    isLoading,
    refetch: refetchDetails,
  } = useQuery({
    queryKey: ["getShowConsumable", id],
    queryFn: () => getShowConsumable(user?.token, id),
    enabled: !!id,
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
  });
  const handleEnableDisableConsumable = async (value, id) => {
    const data = await putEnableDisableConsumable(user?.token, value, id);
    if (data.status.status === "SUCCESS") {
      toast.success(`Consumable ${value ? "Enable" : "Disable"} Successfully`);
      // navigate("/admin/consumable");
      refetchDetails();
    }
  };
  // const columns = [
  //   {
  //     title: "ID",
  //     dataIndex: "id",
  //     key: "id",
  //   },
  //   {
  //     title: "Name",
  //     dataIndex: "name",
  //     key: "name",
  //   },
  //   {
  //     title: "Code",
  //     dataIndex: "code",
  //     key: "code",
  //   },
  //   {
  //     title: "Amount",
  //     dataIndex: "amount",
  //     key: "amount",
  //     render: (amount) => (amount ? `₹${amount.toFixed(2)}` : "N/A"),
  //   },
  //   {
  //     title: "Consumable Category",
  //     dataIndex: "consumable_category",
  //     key: "consumable_category",
  //     render: (_, record) => (
  //       <Link
  //         to={`/admin/consumable_categories/${record?.consumable_category?.id}`}
  //         style={{ textDecoration: "underline" }}
  //       >
  //         {record?.consumable_category?.name}
  //       </Link>
  //     ),
  //   },
  //   {
  //     title: "MRP",
  //     dataIndex: "mrp",
  //     key: "mrp",
  //     render: (mrp) => (mrp ? `₹${mrp.toFixed(2)}` : "N/A"),
  //   },
  //   {
  //     title: "Discount",
  //     dataIndex: "discount",
  //     key: "discount",
  //     render: (discount) => `${discount}%`,
  //   },
  //   {
  //     title: "Unit",
  //     dataIndex: "unit",
  //     key: "unit",
  //   },
  //   {
  //     title: "Active",
  //     dataIndex: "active",
  //     key: "active",
  //     render: (active) => (active ? "Yes" : "No"),
  //   },
  //   {
  //     title: "Created At",
  //     dataIndex: "created_at",
  //     key: "created_at",
  //     render: (created_at) =>
  //       dayjs(created_at, "YYYY-MM-DD HH:mm:ss A").format(
  //         "MMMM DD, YYYY HH:mm"
  //       ),
  //   },
  //   {
  //     title: "Updated At",
  //     dataIndex: "updated_at",
  //     key: "updated_at",
  //     render: (updated_at) =>
  //       dayjs(updated_at, "YYYY-MM-DD HH:mm:ss A").format(
  //         "MMMM DD, YYYY HH:mm"
  //       ),
  //   },
  // ];
  return (
    <>
      <Header />
      <Sidebar activeClassName="consumable-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Consumable Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Consumable Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate("/admin/update_consumable", {
                                    state: getConsumableDetails,
                                  });
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>
                              {getConsumableDetails?.active ? (
                                <button
                                  className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                  style={{
                                    minWidth: "100px",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                  }}
                                  onClick={() => {
                                    handleEnableDisableConsumable(
                                      false,
                                      getConsumableDetails?.id
                                    );
                                  }}
                                >
                                  <i
                                    className="fa fa-ban me-2"
                                    aria-hidden="true"
                                  ></i>
                                  Disable
                                </button>
                              ) : (
                                <button
                                  className="btn btn-sm btn-danger d-flex align-items-center justify-content-center "
                                  style={{
                                    minWidth: "100px",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                  }}
                                  onClick={() => {
                                    handleEnableDisableConsumable(
                                      true,
                                      getConsumableDetails?.id
                                    );
                                  }}
                                >
                                  <i
                                    className="fa fa-toggle-on me-2"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Enable
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430}
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">ID:</span>{" "}
                                  <span className="text">
                                    {getConsumableDetails?.id || "Empty"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Name:</span>{" "}
                                  <span className="text">
                                    {getConsumableDetails?.name || "Empty"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Code:</span>{" "}
                                  <span className="text">
                                    {getConsumableDetails?.code || "Empty"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Amount:</span>{" "}
                                  <span className="text">
                                    {getConsumableDetails?.amount
                                      ? `₹${getConsumableDetails.amount.toFixed(
                                          2
                                        )}`
                                      : "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">
                                    Consumable Category:
                                  </span>{" "}
                                  <span className="text">
                                    <Link
                                      to={`/admin/consumable_categories/${getConsumableDetails?.consumable_category?.id}`}
                                      style={{ textDecoration: "underline" }}
                                    >
                                      {getConsumableDetails?.consumable_category
                                        ?.name || "Empty"}
                                    </Link>
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">MRP:</span>{" "}
                                  <span className="text">
                                    {getConsumableDetails?.mrp
                                      ? `₹${getConsumableDetails.mrp.toFixed(
                                          2
                                        )}`
                                      : "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Discount:</span>{" "}
                                  <span className="text">
                                    {getConsumableDetails?.discount
                                      ? `${getConsumableDetails.discount}%`
                                      : "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Unit:</span>{" "}
                                  <span className="text">
                                    {getConsumableDetails?.unit || "Empty"}
                                  </span>
                                </li>

                                <li className="pb-1">
                                  <span className="title">Created At:</span>{" "}
                                  <span className="text">
                                    {getConsumableDetails?.created_at
                                      ? formatDateTime(getConsumableDetails?.created_at)
                                      : "Empty"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Updated At:</span>{" "}
                                  <span className="text">
                                    {getConsumableDetails?.updated_at
                                      ? formatDateTime(getConsumableDetails?.updated_at)
                                      : "Empty"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Active:</span>{" "}
                                  <span className="text">
                                    {getConsumableDetails?.active === true && (
                                      <span className="custom-badge status-green">
                                        {"Yes"}
                                      </span>
                                    )}
                                    {getConsumableDetails?.active === false && (
                                      <span className="custom-badge status-pink">
                                        {"NO"}
                                      </span>
                                    )}
                                    {getConsumableDetails?.active === null && (
                                      <span className="custom-badge status-pink">
                                        {"NO"}
                                      </span>
                                    )}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      // <div className="table-responsive">
                      //   <Table
                      //     columns={columns}
                      //     dataSource={[getConsumableDetails]}
                      //     pagination={false}
                      //     scroll={{ x: "max-content" }}
                      //   />
                      // </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default ShowConsumable;
